import { anchorLink } from "../include/module";
(() => {
  anchorLink();
})();

import { scrollSocial } from "../include/module";
(() => {
  scrollSocial();
})();

import { scrollPagetop } from "../include/module";
(() => {
  scrollPagetop();
})();

import { scrollHeader } from "../include/module";
(() => {
  scrollHeader();
})();

import { toggleMenu } from "../include/module";
(() => {
  toggleMenu();
})();

import { scrollKira } from "../include/module";
(() => {
  scrollKira();
})();

import { setTableOfContents } from "../include/module";

import { preLoad } from "../include/module";
(() => {
  preLoad();
})();


$(window).on('load', function() {
  setTableOfContents();
});



// WEBPACK FOOTER //
// ./src/argo-bdp_v2/assets/js/live/script.js